// extracted by css-extract-rspack-plugin
export default {"cls1":"SingleClaimPage-cls1_jfM","cls2":"SingleClaimPage-cls2_oSc SingleClaimPage-cls1_jfM"};